<template>
  <div class="basics">
    <Header :present-page="presentPage" />
    <div class="container">
      <h5>后台配置</h5>
      <a-form class="a-form">
        <a-form-item label="系统名称">
          <a-input
            class="ipt"
            v-model:value="formState.systemName"
            placeholder="请输入"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="公司名称">
          <a-input
            class="ipt"
            v-model:value="formState.corporateNameChinese"
            placeholder="请输入"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="公司英文">
          <a-input
            class="ipt"
            v-model:value="formState.corporateNameEnglish"
            placeholder="请输入"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="版权信息">
          <a-input
            class="ipt"
            v-model:value="formState.copyright"
            placeholder="请输入"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="登录背景图">
          <a-upload
            list-type="picture-card"
            v-model:file-list="fileList"
            :customRequest="customRequest"
            :beforeUpload="beforeUpload"
            @preview="handlePreview"
          >
            <div v-if="fileList.length < 1">
              <loading-outlined v-if="loading"></loading-outlined>
              <plus-outlined
                v-else
                :style="{color: '#aaa', fontSize: '32px'}"
              ></plus-outlined>
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item>
          <!-- <a-button class="cancel">取消</a-button> -->
          <a-button
            class="confirm"
            @click="handleSubmit"
          >保存</a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
    >
      <img
        alt="example"
        style="width: 100%"
        :src="previewImage"
      />
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import _global from '@/utils/global'
import Header from "@/components/header/header.vue";
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue';
import { pageOption, alterPageOption } from '@/api/login/login.js';
import { upload } from "@/api/project/project.js";

export default {
  name: "Basics",
  components: {
    Header,
    PlusOutlined,
    LoadingOutlined,
  },
  data() {
    return {
      presentPage: '',
      baseURL: _global.baseURL,
      query: {},
      formState: {
        systemName: '',
        corporateNameChinese: '',
        corporateNameEnglish: '',
        copyright: '',
        background: '',
      },
      loading: false,
      imageUrl: '',
      fileList: [
        {
          uid: '-1',
          status: 'done',
          url: '',
        },
      ],
      previewVisible: false,
      previewImage: ''
    };
  },
  mounted() {
    this.presentPage = '后台配置'
    pageOption(this.query).then(res => { //页面配置
      if (res.code == 200) {
        this.formState = res.data
        this.fileList[0].url = this.baseURL + this.formState.background[0]
        this.previewImage = this.baseURL + this.formState.background[0]
      }
    }).catch(res => {
      console.log(res)
    });
  },
  methods: {
    handleSubmit() {
      console.log(this.formState.background)
      this.formState.background = this.formState.background.join(',')
      alterPageOption(this.formState).then(res => { //修改页面配置
        if (res.code == 200) {
          this.$message.success(res.data);
          localStorage.setItem('pageOption', JSON.stringify(this.formState))
          setTimeout(() => {
            this.$router.go(0);
          }, 1000);
        }
      }).catch(res => {
        console.log(res)
      });
    },
    handlePreview() {
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    customRequest(option) {
      console.log(option)
      // option.onProgress({ percent: 50 })
      getBase64(option.file, imageUrl => {
        // this.formState.productPhotoTemp = imageUrl;
        this.loading = false;
      });
      const formData = new FormData()
      const uploadDto = [{
        fileName: option.file.name,
        type: 1
      }]
      formData.append('files', option.file)
      formData.append('uploadDto', JSON.stringify(uploadDto))
      upload(formData).then(res => { //上传图片
        if (res.code == 200) {
          this.formState.background = res.data[0].filePath
          this.previewImage = this.baseURL + res.data[0].filePath
          option.onSuccess()
        }
      }).catch(res => {
        console.log(res)
      });
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
  },
};
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
</script>
<style scoped>
.container {
  padding: 20px;
  margin: 20px 30px;
  background: #fff;
  border-radius: 15px;
}
h5 {
  width: 600px;
  padding-left: 10px;
  margin: 20px auto;
  text-align: left;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222;
  border-left: 5px solid #0088ff;
}
.a-form {
  width: 600px;
  margin: 0 auto;
}
.a-form :deep() .ant-form-item-label > label {
  width: 100px;
  height: 40px;
}
.ipt {
  width: 500px;
  height: 40px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.a-form :deep() .cancel {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.a-form :deep() .confirm {
  width: 80px;
  height: 36px;
  color: #fff;
  border: 0;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.a-form :deep() .ant-form-item-control-input-content {
  text-align: right;
}
</style>